import React from 'react';
import ShipmentForm from '../ShipmentForm/ShipmentForm';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <div className="hero-wrap hero-section" data-stellar-background-ratio="0.5">
      <div className="overlay"></div>
      <div className="container">
        <div className="row no-gutters slider-text justify-content-start align-items-center">
          <div className="col-lg-6 col-md-6 ftco-animate d-flex align-items-end">
            <div className="text">
              <h1 className="mb-4">Now <span>It's easy for you</span> <span>ship a vehicle</span></h1>
              <p className="hero-description">
                Get fast, reliable, and hassle-free auto shipping at the best rates.
                Whether you are moving, buying, or selling – we make vehicle transport simple and stress-free!
              </p>
            </div>
          </div>
          <div className="col-lg-2 col"></div>
          <div className="col-lg-4 col-md-6 mt-0 mt-md-5 d-flex">
            <ShipmentForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;


